<div class="questionnaire">
    <div class="questionnaire-dialog__header d-flex justify-content-between align-items-center">
        <img src="assets/images/gov-surevy-logo.png" alt="gov.in" width="200" height="49" class="gov-logo" />
        <button class="questionnaire-dialog__close" (click)="questionnaireDialogRef.close()">
        <img src="https://media.umangapp.in/cdn/landing/close.svg" alt="" width="24" height="24" alt="close" />
        </button>
    </div>
    
    <div class="questionnaire-dialog__content p-4">
        <h4>We are conducting surveys for both users and developers. We request your support in providing feedback for the concerned link given below.</h4>
        <ng-container *ngIf="questionnaireDataList.length;">
            <ul>
                <li *ngFor="let question of questionnaireDataList">
                    <a [href]="question?.url" target="_blank" rel="noopener noreferrer">
                        {{ question?.title }}
                </a>
                </li>
            </ul>
        </ng-container>
    </div>
</div>